import React from "react";

export function Loader({ label = "Loading SpectralX" }) {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#060B19]" data-testid="app-loader">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="relative flex flex-col items-center gap-6">
        <div className="relative">
          <div className="loader-ring" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-display font-black text-[#00F0FF] text-lg neon-text">S</span>
          </div>
        </div>
        <div className="text-xs uppercase tracking-[0.4em] text-[#94A3B8] animate-pulse">{label}</div>
      </div>
    </div>
  );
}
